import React, { useEffect, useState } from "react";

import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { SwarovskiPageDataFrontend } from "@swo/storefront";
import { useStore } from "../../../store/hooks/use-store";

import { useEnvironment } from "../../../hooks/use-environment";
import { useToolbarStateCtx } from "./ToolbarStateProvider";

const LAZY_ClientSideCMSEditOverlay = React.lazy(() =>
  import("./ClientSideCMSEditOverlay").then(m => ({ default: m.ClientSideCMSEditOverlay_Root })),
);

export const CMSEditOverlay: ReactTFC<{ pageData: SwarovskiPageDataFrontend }> = props => {
  const env = useEnvironment();

  const { state } = useToolbarStateCtx();

  const {
    state: {
      config: { preview },
    },
  } = useStore();

  return env === "browser" && state ? (
    <React.Suspense fallback={null}>
      <LAZY_ClientSideCMSEditOverlay pageData={props.pageData} mode={preview ? "preview" : "published"} />
    </React.Suspense>
  ) : null;
};
